import { StaticBaseDao } from '@/dao';
import { RaceContestantComplete, PostResponse } from '@/objects/generated';

export class RaceContestantCompleteDao extends StaticBaseDao {
    public static async DeleteRaceContestants(EventID: number, items: RaceContestantComplete[]): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `RaceContestantComplete/DeleteRaceContestants` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            items,
        );
    }
}
